
import HaveQuestionsForm from '@/components/shared/HaveQuestionsForm'
export default {
  components: { HaveQuestionsForm },
}
